module.exports = __webpack_public_path__ + "img/SweewatersSanctuaryLogo_horizontal.f2fc36dd.png";